export const SET_FILTERS_LUCENE_QUERY_STRING = 'SET_FILTERS_LUCENE_QUERY_STRING';
export const SET_SORT_FIELD = 'SET_SORT_FIELD';
export const SET_SORT_DIRECTION = 'SET_SORT_DIRECTION';
